import { TNotice } from 'domain/notice/types';
import { createAsyncAction } from 'typesafe-actions';

export const noticeActions = createAsyncAction(
  'ENV_NOTICE_REQUEST',
  'ENV_NOTICE_SUCCESS',
  'ENV_NOTICE_FAILURE'
)<void, { notices: TNotice }, Error>();
